module.exports = __webpack_public_path__ + "img/renshi_banner.a11b6110.png";